import { render } from "./DonatorsList.vue?vue&type=template&id=7ed8ca2e&scoped=true"
import script from "./DonatorsList.vue?vue&type=script&lang=js"
export * from "./DonatorsList.vue?vue&type=script&lang=js"

import "./DonatorsList.vue?vue&type=style&index=0&id=7ed8ca2e&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed8ca2e"]])

export default __exports__